export const orgConstants = {
  LOAD_ORG: "LOAD_ORG",
  SET_ORG: "SET_ORG"
};
